import moment from "moment";
import React from "react";
import { momentToTzDate, timeZone } from "./DatePickerBase";
import getConfiguredLocale from "./getConfiguredLocale";
import { DayPicker } from "react-day-picker";
import { getElementToSkipFocusTo } from "keyboardNavigation/utils";

export interface InlineDatePickerProps {
  value: moment.Moment;
  onChange: (value: moment.Moment) => void;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
}

export const InlineDatePicker = (props: InlineDatePickerProps) => {
  const { value } = props;
  const minDate = props.minDate ?? moment.utc().subtract(10, "year");
  const maxDate = props.maxDate ?? moment.utc().add(5, "year");

  const onChange = (v: moment.Moment) => {
    const newValue = value.clone();

    // DatePicker only sets DD-MM-YYYY, not the time. We want to preserve the time
    newValue.year(v.year());
    newValue.month(v.month());
    newValue.date(v.date());

    props.onChange(newValue);
  }

  const isDayDisabled = (date: Date): boolean => {
    const m = moment.utc(date);
    if (m.isAfter(maxDate) || m.isBefore(minDate)) {
      return true;
    }

    return false;
  }

  const valueTz = momentToTzDate(value);

  const onSelect = (newVal: Date) => {
    onChange(moment.utc(newVal));
  }

  return <DayPicker
    required
    startMonth={momentToTzDate(minDate)}
    endMonth={momentToTzDate(maxDate)}
    disabled={isDayDisabled}
    captionLayout="dropdown"
    timeZone={timeZone}
    locale={getConfiguredLocale(serverReference.culture.uiLocale)}
    selected={valueTz}
    onSelect={onSelect}
    fixedWeeks
    showOutsideDays
    formatters={{
      formatWeekdayName: (date) => serverReference.abbreviatedDayLetters[date.getDay()]
    }}
    // Skip focus on days
    onDayFocus={(_, __, e) => {
      const skipTo = getElementToSkipFocusTo("rdp-day_button", e.relatedTarget as HTMLElement);
      skipTo?.focus();
    }}
    mode="single"
  />
}